import { EmployeeRole } from "../../../Utilities";

export enum EmployeeRoleCategory {
	Teachers = "Teachers",
	Administration = "Administration",
	FinancialTeam = "Financial Team",
	Staff = "Staff",
}

export const employeeRoleCategories: EmployeeRoleCategory[] = [
	EmployeeRoleCategory.Teachers,
	EmployeeRoleCategory.Administration,
	EmployeeRoleCategory.FinancialTeam,
	EmployeeRoleCategory.Staff,
];

export function getRoleCategory(role: EmployeeRole) {
	switch (role) {
		case EmployeeRole.Teacher:
			return EmployeeRoleCategory.Teachers;
		case EmployeeRole.AcademicAdmin:
		case EmployeeRole.GeneralAdmin:
		case EmployeeRole.PrincipalAdmin:
			return EmployeeRoleCategory.Administration;
		case EmployeeRole.FinancialAdmin:
			return EmployeeRoleCategory.FinancialTeam;
		case EmployeeRole.GeneralStaff:
		case EmployeeRole.FrontDesk:
		case EmployeeRole.MedicalStaff:
			return EmployeeRoleCategory.Staff;
	}
}
